import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { Text } from '../Elements';
import error from 'assets/svg/error.png';

import classes from './EmptyState.module.scss';

const EmptyState = ({ message = 'empty' }) => {
  const { t } = useTranslation('activity');

  const text = () => {
    switch (message) {
      case 'empty': {
        return t('activity:errors.EMPTY_STATE');
      }
      case 'connect': {
        return t('activity:errors.NO_CONNECTION');
      }
      default:
        return message;
    }
  };

  return (
    <div className={classes.empty}>
      <img
        className={classes.error}
        src={error}
        width={message === 'connect' ? 437 : 155}
        height={message === 'connect' ? 400 : 150}
        alt=""
      />
      <Text type="p" className={classes.emptyState}>
        {text()}
      </Text>
      {message === 'connect' && (
        <Text type="p" weight="b" className={classes.text}>
          {t('activity:errors.NO_CONNECTION_2')}
        </Text>
      )}
      {message === 'connect' && (
        <Text type="p" className={classes.text_sub}>
          {t('activity:errors.NO_CONNECTION_SUB')}
        </Text>
      )}
    </div>
  );
};

EmptyState.propTypes = {
  message: PropTypes.string
};

export default EmptyState;
